import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as IconTrash } from '../../../../../../assets/icons/svg/shared/ic-shared-trash.svg';

const MarkBillAsCanceledSuccess = ({ billNumber }: { billNumber: string }) => {
  const { t } = useTranslation();
  return (
    <div className='text-bw00 text-lg font-metricR items-center justify-center flex w-full grow'>
      <IconTrash className='stroke-bw00 mr-[10px]' />
      {t('BILL_PAY.MARK_AS_CANCELED.TOAST_SUCCESS.BILL')}
      <div className='flex mx-[5px]'>{`#${billNumber}`}</div>
      <span className='font-metricRSemibold'>{t('BILL_PAY.MARK_AS_CANCELED.TOAST_SUCCESS.CANCELED')}</span>
    </div>
  );
};

export default MarkBillAsCanceledSuccess;
